var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSavedQueries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.394,
    height: 20.402,
    viewBox: "0 0 20.394 20.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d",
    "data-name": "pGEIU1.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.964.075c3.294.123,6.761-.204,10.035-.013.963.056,1.886.409,2.618,1.035.784.67,1.961,1.858,2.643,2.638.652.745,1.004,1.673,1.071,2.662-.146,3.258.196,6.689.002,9.927-.123,2.047-1.587,3.682-3.606,4.017-4.355.088-8.732.076-13.087.006C1.629,20.063.125,18.376.002,16.361l-.002-12.31C.152,1.904,1.822.239,3.964.075ZM4.25,1.77c-.871-.04-1.751.463-2.19,1.204-.283.477-.364.923-.392,1.474-.193,3.819.148,7.799.002,11.635.085,1.386.88,2.398,2.281,2.602l12.504-.006c1.114-.18,1.996-1.043,2.164-2.164-.047-3.215.214-6.601.046-9.804-.035-.67-.17-1.255-.599-1.784l-2.004-2.006c-.123,1.571-1.163,3.021-2.63,3.603-1.166.463-3.578.389-4.876.329-1.461-.068-2.722-.616-3.561-1.839-.308-.449-.746-1.413-.746-1.954v-1.29ZM14.415,1.81l-8.497-.04v1.092c0,1.126,1.242,2.2,2.321,2.284,1.038.081,2.772.074,3.815,0,1.126-.079,2.361-1.15,2.361-2.324v-1.012Z",
    fill: "#bababa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.758,9.526c1.851-1.851,5.079-.971,5.684,1.574.644,2.709-1.963,4.983-4.557,3.961-2.221-.875-2.812-3.851-1.127-5.535ZM9.879,10.237c-1.846.251-1.85,3.109-.04,3.354,2.71.367,2.614-3.704.04-3.354Z",
    fill: "#bababa"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedQueries);
export default __webpack_public_path__ + "static/media/SavedQueries.d9ba130e.svg";
export { ForwardRef as ReactComponent };